"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DietaryInformationModal = void 0;
const React = require("react");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const Button_1 = require("../../../../../components/base/atoms/Button");
const openLink_1 = require("../../../../../helpers/openLink");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "DietaryInformationModal");
const DietaryInformationModal = ({ open, setOpen }) => {
    // links and helper functions to bring up dietary information
    const { orderingNutritionInfoLink, orderingAllergenInfoLink } = env;
    return (React.createElement(Modal_1.Modal, { open: open, onClose: () => setOpen(false), size: dialogs_1.TDialogSizes.Medium, showCloseIcon: true, closeOnOverlayClick: true, closeOnEsc: true, appMode: true },
        React.createElement("div", { className: css("") },
            React.createElement(Modal_1.ModalHeader, null, "Dietary Information"),
            React.createElement(Modal_1.ModalBody, null, "Want to know more? Access our nutritional and allergen information."),
            React.createElement(Modal_1.ModalFooter, null,
                React.createElement(Button_1.BlockButton, { className: css("button_nutrition"), onClick: () => (0, openLink_1.openLink)(orderingNutritionInfoLink) }, "Nutrition"),
                React.createElement(Button_1.BlockButton, { className: css("button_allergen"), onClick: () => (0, openLink_1.openLink)(orderingAllergenInfoLink) }, "Allergen")))));
};
exports.DietaryInformationModal = DietaryInformationModal;
//# sourceMappingURL=index.js.map